export default __webpack_public_path__ + "static/media/CancelPatient.0ae03823.svg";